import type { ReviewDetail } from '../types/review';

export const review: ReviewDetail = {
  id: '',
  img: '',
  title: '',
  location: '',
  star: 0,
  openClose: '',
  price: '',
  outlet: '',
  light: '',
  noise: '',
  content: '',
  hashtag: [],
};
